import { SCORING_API_BASE_URL, authHeaders } from '../services/api';

/**
 * Déclenche le calcul agrégé dashboard (Mongo + sessions make-up côté client).
 * Fire-and-forget depuis l’écran résultats ; le dashboard relit les mêmes agrégats.
 */
export async function triggerDashboardCompute(userId, examId, makeupSessions, sessionId) {
    const res = await fetch(`${SCORING_API_BASE_URL}/api/dashboard/compute`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({
            user_id: userId,
            exam_id: examId,
            session_id: sessionId || undefined,
            makeup_sessions: makeupSessions || [],
        }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
        throw new Error(data.error || `dashboard compute failed ${res.status}`);
    }
    return data.dashboard;
}
